'use strict'

attributeNames =
  extraDiscount: 'data-formatted-extra-discount'
  discountPercentage: 'data-discount-percentage'
  offerLabel: 'data-offer-label'
  price: 'data-formatted-price'
  regularPrice: 'data-formatted-regular-price'
  value: 'data-formatted-value'

classNames =
  bannerMessage: 'juice-banner-message'
  juiceProgramEnabled: 'juice-program-enabled'
  juiceProgramExpired: 'juice-program-expired'

selectors =
  bannerMessage: ".#{classNames.bannerMessage}"
  discountBadge: '.breakout-pricing-messages .discount-message-wrapper'
  extraDiscount: ".#{classNames.bannerMessage} .extra-discount"
  inlineOptionInput: '.multi-option-breakout input'
  multiOptionOverlay: '.multi-option-overlay'
  multiOptionOverlayInput: '.multi-option-overlay-item input'
  offerLabel: '.breakout-pricing-messages .urgency-pricing-label'
  overlayClusterDiscount: '.multi-option-overlay-cluster-row .discount-message'
  overlayClusterPrice: '.multi-option-overlay-cluster-price'
  purchaseCluster: '#purchase-cluster'
  timerInBannerMessage: ".#{classNames.bannerMessage} .time-left"
  viewMoreButton: '.view-options a'

module.exports = {attributeNames, classNames, selectors}
